<ng-container *transloco="let t; read: 'findMyAgent.important'">
  <label class="text-heading-2 text-steel-100 mb-6 block" id="important-label">{{
    t('title', { propertyType: store.propertyType$ | async })
  }}</label>
  <rma-group-select class="grid grid-cols-1 gap-4 lg:grid-cols-2" [formControl]="criterionControl" aria-labelledby="important-label">
    @for (option of options; track option; let i = $index) {
      <rma-group-select-option #optionItem [option]="{ label: option, value: option }" [optionTemplate]="optionTemplate" [tabindex]="i + 1">
        <ng-template #optionTemplate>
          <div
            class="bg-blue-10 hover:text-blue-10 active:text-blue-10 flex flex-col items-center justify-center p-4 font-bold text-blue-100 hover:bg-blue-50 focus:border focus:border-blue-100 active:bg-blue-100"
            [class.bg-blue-100]="optionItem.selected"
            [class.text-blue-10]="optionItem.selected"
            [attr.data-id]="'importance-' + option">
            <span>{{ t('label.' + option) }}</span>
          </div>
        </ng-template>
      </rma-group-select-option>
    }

    <button
      class="bg-blue-10 hover:text-blue-10 active:text-blue-10 flex w-full flex-col items-center justify-center p-4 font-bold text-blue-100 hover:bg-blue-50 focus:border focus:border-blue-100 active:bg-blue-100"
      [class.hidden]="showOtherInputFlag"
      (click)="showOtherInput()"
      type="button"
      data-id="importance-other">
      <span>{{ t('label.other') }}</span>
    </button>
  </rma-group-select>

  @if (showOtherInputFlag) {
    <div class="mt-8 flex w-full flex-col lg:items-end">
      <mat-form-field class="w-full" [floatLabel]="'always'" appearance="outline">
        <mat-label>{{ t('other-reason-label') }}</mat-label>
        <input [formControl]="otherReasonControl" (keyup.enter)="submit()" matInput placeholder="" />
      </mat-form-field>
      <button class="w-full lg:w-fit" (click)="submit()" mat-flat-button type="button" color="primary">{{ t('submit') }}</button>
    </div>
  }
</ng-container>
